var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4314 0.574517C22.1895 1.34054 22.1895 2.58254 21.4314 3.34848L8.49021 16.4255C7.73211 17.1915 6.50322 17.1915 5.74504 16.4255L0.568553 11.1947C-0.189518 10.4286 -0.189518 9.18683 0.568553 8.42078C1.32662 7.65473 2.55573 7.65473 3.3138 8.42078L7.11766 12.2644L12.9019 6.41948L18.6863 0.574517C19.4444 -0.191506 20.6733 -0.191506 21.4314 0.574517Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.9b079a4ca4f4f6934880a12bcd77eea3.svg";
export { ForwardRef as ReactComponent };